// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__jFCS2","inputWrap":"styles_inputWrap__1142I","input":"styles_input__2Jt6w"};